module.exports = __webpack_public_path__ + "static/media/Ravi Vempati.924bc195.png";